import React, { Component } from "react";
import Popup from "reactjs-popup";
import axios from 'axios';
import { Grid, GridColumn, GridNoRecords, GridToolbar } from '@progress/kendo-react-grid';
import { process } from '@progress/kendo-data-query';
import { Button } from "@progress/kendo-react-buttons";
import { Input } from "@progress/kendo-react-inputs";

class AddMapping extends Component {

  constructor(props) {
    super(props);

    var columns = [
        // { field: 'selected', title: '', width: 50, filterable: false, cell: (p) => {
        //     return (
        //         <td style={{ textAlign: 'center' }}>
        //             <input type="checkbox" checked={p.dataItem.selected || false} onChange={(e) => { this.onLabelChange(p, e.target.checked) }} />
        //         </td>
        //     )
        // }},
        { field: 'interfaceCode', title: 'Interface Code', headerClass: 'gridHeader', minWidth: 150, cell: (p) => this.createCodeCell(p) },
        { field: 'interfaceName', title: 'Interface Name', headerClass: 'gridHeader', minWidth: 150, cell: (p) => this.createNameCell(p) },
    ]


    this.state = {
      updates: [],
      dataState: {},
      columns: columns,
      result: null,
      demographics: null,
      refreshText: '',
    }
  }

  componentDidMount() {

  }

  getDemographics = (cb) => {
    this.setState({ interfaceCode: '', interfaceName: '' })
    var demographics = [{interfaceCode: '', interfaceName: '', }]

            var result = process(demographics, this.state.dataState)
            console.log(result)
            this.setState({ demographics: demographics, result: result, refreshText: '' })
  }

  updateDemographics(cb) {
    this.setState({ refreshText: 'Loading...' })
    var headers = { 'authorization': 'Bearer '.concat(this.props.idToken) };

    var payload = {
      company: this.props.user.company,
      interfaceCode: this.props.interfaceCode,
      interfaceName: this.state.interfaceName,
    };

    axios.post('api/customDemographicsEntity', payload, { headers }).then(response => {
      console.log(response)
      cb()

    })
      .catch(err => {
        console.error(err);
      })
  }

  clearState = () => {
    this.setState({
      updates: [],
      dataState: {},
      result: null,
      demographics: null
    });
  }

  onValueChange(cell, value) {
    const demographics = [...this.state.demographics];

    const i2 = demographics.findIndex(
        e => e.key === cell.dataItem.key
    );

    if (i2 > -1) {
        demographics[i2] = {
            ...demographics[i2],
            [cell.field]: value
        };
    }

    const result = process(demographics, this.state.dataState);

    this.setState({
        demographics,
        result,
        [cell.field]: value
    });
  }

  onLabelChange(cell, value) {
    var demographics = this.state.demographics
    // const i = updates.findIndex(e => e.Label === Label);
    const i2 = demographics.findIndex(e => e.key === cell.dataItem.key);
    if (i2 > -1) {
      demographics[i2].Label = value
    }
    var result = process(demographics, this.state.dataState)
    this.setState({ demographics: demographics, result: result })
  }

  addNewRow() {
    var demographics = this.state.demographics
    demographics.push({
      EntityCode: this.props.entity,
      Label: '',
      LabelValue: '',
      Date: new Date().toLocaleDateString("en-US", { timeZone: "UTC" }),
      key: demographics.length,
    })
    var result = process(demographics, this.state.dataState)
    this.setState({ demographics: demographics, result: result, refreshText: '' })
  }

  delete(cb) {
    if (window.confirm('Are you sure you want to delete all custom demographic data for ' + this.props.entity + '? This cannot be undone')) {
      this.setState({ refreshText: 'Loading...' })
      var headers = { 'authorization': 'Bearer '.concat(this.props.idToken) };

      var payload = {
        company: this.props.user.company,
        entity: this.props.entity,
        custom: true
      };

      axios.post('api/demographicsEntityDelete', payload, { headers }).then(response => {
        console.log(response)
        cb(true)

      })
        .catch(err => {
          console.error(err);
        })
    }
    else { cb(false) }
  }

  createCodeCell = (cell) => {
    return (
      <td>
        <Input defaultValue={cell.dataItem.interfaceCode} style={{width:'100%'}} key={cell.dataItem.key + 'Code'} value={cell.dataItem.interfaceCode} onChange={(e) => { this.onValueChange(cell, e.target.value) }} />
      </td>
    );
  }

  createNameCell = (cell) => {
    return (
      <td>
        <Input defaultValue={cell.dataItem.interfaceName} style={{width:'100%'}} key={cell.dataItem.key + 'Name'} value={cell.dataItem.interfaceName} onChange={(e) => { this.onValueChange(cell, e.target.value) }} />
      </td>
    );
  }

    addEntry(cb) {


       this.setState({ refreshText: 'Loading...' })
        var headers = { 'authorization': 'Bearer '.concat(this.props.idToken) };

      const payload = {
        company: this.props.user.company,
          interfaceCode: this.state.interfaceCode,
          interfaceName: this.state.interfaceName
      };

        axios.post('api/addInterfaceMapping', payload, { headers }).then(response => {
          console.log(response)
          if (response.data.code === 409) {
            alert('An entry for this interface code already exists. Please use a unique code or delete the existing entry.')
            cb(false)
          }
          else if (response.data.code !== 200) { 
            alert('An error occurred while saving.')
          cb(false)
          }
          else {
            cb(true)
          }

        })
      .catch(err => {
        console.error(err);
        cb(false);
      })
    };

  changeDataState = (e) => {
    var data = { ...e.dataState }
    if (data.filter != null && data.filter.filters != null) {
      data.filter.filters.forEach(item => {
      })
      // data.filter.filters = data.filter.filters.filter(item => item.value !== '(All)');
    }
    var newData = process(this.state.demographics, data);
    this.setState({ dataState: data, result: newData });
  }

  render() {
    return (
      <Popup closeOnDocumentClick={false} trigger={this.props.button} onOpen={() => { this.getDemographics() }} onClose={() => { this.clearState() }} overlayStyle={{ zIndex: 5 }} modal>
        {close => (
          <div className="modal">
            <Button className="close" icon="close" onClick={(e) => { close(); }} />
            <div className="header" align="left">
              Account List -{this.props.interfaceCode}
            </div>
            <div className="content">
              <Grid data={this.state.result}
                style={{maxHeight:'65vh'}}
                onDataStateChange={this.changeDataState}
                {...this.state.dataState}>
                <GridNoRecords>
                  {this.state.refreshText && ''}
                  {!this.state.refreshText && 'No records available'}
                </GridNoRecords>
                <GridToolbar>
                  {/* <Button icon='refresh' title='Refresh' onClick={(e) => this.getDemographics()}>{this.state.refreshText}</Button> */}
                  {/* <Button icon="delete" title='Delete' onClick={() => { this.delete((cb) => { if (cb) { close() } }) }}>Delete All Custom Data</Button>
                  <Button icon="plus" title='New' onClick={() => { this.addNewRow() }}>Add Row</Button> */}
                </GridToolbar>
                {
                  this.state.columns.map((column, key) => {
                    return <GridColumn  field={column.field} title={column.title} key={key} format={column.format} cell={column.cell} filterable={column.filterable} filterCell={column.filterCell} filter={column.filter} headerClassName={column.headerClass} width={column.width} />
                  })
                }
                {/* <GridColumn field="InterfaceCode" key='InterfaceCode' title="Interface Code" width="250px" filterable={true} cell={this.createLabelcell} /> */}
                {/* <GridColumn field="portfolio_Id" key='account' title="Account" width="250px" filterable={true} cell={this.createLabelcell} /> */}
              </Grid>
            </div>
            <div className="actions">
              <Button
                className="button"
                onClick={() => { close(); }}>
                Close
              </Button>
              <Button
                className="upload"
                onClick={() => { this.addEntry((cb) => {
                     if (cb) {
                         close();
                         this.props.refresh();
                     }
                }) }}>
                Save
              </Button>
            </div>
          </div>
        )}
      </Popup>

    );
  };
}

export default AddMapping;